import script from "./ShareList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareList.vue?vue&type=script&setup=true&lang=ts"

import "./ShareList.vue?vue&type=style&index=0&id=65f799ef&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f799ef"]])

export default __exports__